import Axios from 'axios';
import Qs from 'qs';

export default {

  // 物业公告分页列表
  listPage(
    title,
    community_ids,
    publish_start,
    publish_end,
    page,
    limit
  ) {
    return Axios.get('/announcement/api/admin/', {
      params: {
        title,
        community_ids,
        publish_start,
        publish_end,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 物业公告列表
  list() {
    return Axios.get('/announcement/api/admin/all', {});
  },

  // 物业公告上线
  online(
    id
  ) {
    return Axios.put(`/announcement/api/admin/${id}/online`);
  },

  // 物业公告下线
  offline(
    id
  ) {
    return Axios.put(`/announcement/api/admin/${id}/offline`);
  },

  // 物业公告删除
  del(
    id
  ) {
    return Axios.delete('/announcement/api/admin/', {
      data: {
        ids: [id]
      }
    });
  },

  // 推送物业公告
  push(
    id
  ) {
    return Axios.put(`/announcement/api/admin/${id}/publish`);
  },

  // 物业公告新增
  add(
    title,
    banner,
    content,
    community_ids,
    accept_owner_type,
    accept_owner,
    accept_owner_building_ids,
    accept_owner_unit_ids,
    accept_owner_floor_ids,
    accept_owner_room_ids,
    is_notify,
    publish_way,
    defer_at
  ) {
    return Axios.post('/announcement/api/admin/', {
      title,
      banner,
      content,
      community_ids,
      accept_owner_type,
      accept_owner,
      accept_owner_building_ids,
      accept_owner_unit_ids,
      accept_owner_floor_ids,
      accept_owner_room_ids,
      is_notify,
      publish_way,
      defer_at,
      accept_property: 0,
      operation: 'publish',
      type: 1
    });
  },

  // 物业公告编辑
  edit(
    id,
    title,
    banner,
    content,
    community_ids,
    accept_owner_type,
    accept_owner,
    accept_owner_building_ids,
    accept_owner_unit_ids,
    accept_owner_floor_ids,
    accept_owner_room_ids,
    is_notify,
    publish_way,
    defer_at
  ) {
    return Axios.put('/announcement/api/admin/', {
      id,
      title,
      banner,
      content,
      community_ids,
      accept_owner_type,
      accept_owner,
      accept_owner_building_ids,
      accept_owner_unit_ids,
      accept_owner_floor_ids,
      accept_owner_room_ids,
      is_notify,
      publish_way,
      defer_at,
      accept_property: 0,
      operation: 'publish',
      type: 1
    });
  },

  // 物业公告详情
  info(
    id
  ) {
    return Axios.get(`/announcement/api/admin/${id}`);
  }

}